// Special tag which only shows results from the product index.
export const PRODUCTS_TAG = '_products';
export const DOCUMENTS_TAG = '_documents';
